import { getCurrentUser } from '../../app/app-state.js';
import { getTg } from '../../core/telegram.js';
import { getEl, getInput, getTextArea } from '../../core/dom.js';

export const ownerChatThreadsEl = getEl('owner-chat-thread-list');
export const ownerChatMessagesEl = getEl('owner-chat-messages');
export const ownerChatComposerEl = getEl('owner-chat-composer');
export const ownerChatInputEl = getTextArea('owner-chat-input');
export const ownerChatSendBtn = getEl<HTMLButtonElement>('owner-chat-send-btn');
export const ownerChatAttachBtn = getEl('owner-chat-attach-btn');
export const ownerChatPhotoInput = getInput('owner-chat-photo-input');
export const ownerChatAttachPreviewEl = getEl('owner-chat-attach-preview');
export const ownerChatAttachThumbEl = getEl<HTMLImageElement>('owner-chat-attach-thumb');
export const ownerChatAttachThumbWrapEl = getEl('owner-chat-attach-thumb-wrap');
export const ownerChatAttachThumbSpinnerEl = getEl('owner-chat-attach-thumb-spinner');
export const ownerChatAttachThumbRingFillEl = document.getElementById(
  'owner-chat-attach-thumb-ring-fill'
) as SVGCircleElement | null;
export const ownerChatAttachThumbPctEl = getEl('owner-chat-attach-thumb-pct');
export const ownerChatAttachRemoveBtn = getEl('owner-chat-attach-remove');
export const ownerChatSubtitleEl = getEl('owner-chat-thread-subtitle');
export const ownerChatListSubtitleEl = getEl('owner-chat-list-subtitle');
export const ownerChatLoadingEl = getEl('owner-chat-loading');

export function getOwnerChatViewerId() {
  var u = getCurrentUser();
  if (!u || u.id == null) {
    try {
      var t = getTg();
      u = t && t.initDataUnsafe && t.initDataUnsafe.user ? t.initDataUnsafe.user : null;
    } catch (_) {
      u = null;
    }
  }
  return u && u.id != null ? String(u.id) : '';
}

export function getOwnerChatViewerUsername() {
  var u = getCurrentUser();
  if (!u) {
    try {
      var t = getTg();
      u = t && t.initDataUnsafe && t.initDataUnsafe.user ? t.initDataUnsafe.user : null;
    } catch (_) {
      u = null;
    }
  }
  return u && u.username ? String(u.username) : '';
}

export function ownerChatNotifySendFailed(reason: 'photo' | 'text') {
  var msg =
    reason === 'photo'
      ? 'Не удалось отправить фото. Попробуйте ещё раз или выберите другое изображение.'
      : 'Не удалось отправить сообщение. Проверьте соединение и попробуйте снова.';
  try {
    var t = getTg();
    if (t && typeof t.showAlert === 'function') {
      t.showAlert(msg);
      return;
    }
  } catch (_) {}
  try {
    const noticeEl = document.getElementById('app-notice');
    if (!noticeEl) return;
    noticeEl.textContent = msg;
    noticeEl.classList.add('app-notice-visible');
    setTimeout(function () {
      try {
        noticeEl.classList.remove('app-notice-visible');
      } catch (_) {}
    }, 3200);
  } catch (_) {}
}
